module.exports = __webpack_public_path__ + "static/media/galerija_2016 (1).27112d56.jpg";